import { BillingPlanCard } from './components/BillingPlanCard';
import { makeTranslator } from './components/format';

import type { AdminBillingElementProps } from './AdminBillingElement.types';

export function AdminBillingElement(props: AdminBillingElementProps) {
  const { element, isLoading, translate } = props;
  const tr = makeTranslator(translate);

  const plans = element.attrs?.data?.plans ?? [];

  if (isLoading) {
    return (
      <div className="flex w-full flex-col gap-4">
        <p className="text-sm text-gray-500">{tr('manage.billing.loading')}</p>
      </div>
    );
  }

  if (plans.length === 0) {
    return (
      <div className="flex w-full flex-col gap-2">
        <p className="text-sm text-gray-500">{tr('manage.billing.empty_state')}</p>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4">
      {plans.map((plan) => (
        <BillingPlanCard key={plan.id} plan={plan} translate={translate} />
      ))}
    </div>
  );
}
